import type { AuthLocation } from '@/types/auth';

/**
 * Resolve the location a new dining table should belong to.
 *
 * The dashboard location filter defaults to "All locations" (`undefined`).
 * A dining table must belong to a concrete location, so when no location is
 * explicitly selected we fall back to the user's first active location
 * (same pattern as the Floor Plan Editor).
 *
 * Returns `undefined` when no usable location exists — callers MUST treat
 * this as "cannot create" and block the request rather than sending an
 * empty string, which the API rejects with a 500
 * (`invalid input syntax for type uuid: ""`). Regression: GitHub issue #71.
 */
export function resolveTableLocationId(
  storeLocationId: string | undefined,
  profileLocations: AuthLocation[] | undefined,
): string | undefined {
  if (storeLocationId) return storeLocationId;
  return profileLocations?.find((l) => l.is_active)?.id ?? undefined;
}
